import React from "react";
import Select from "react-select";
import { getIn } from "formik";

export default class Search extends React.Component<any, any> {
  componentDidMount() {
    const { field, form, options = [] } = this.props;
    if (form.getFieldMeta(field.name).value === undefined) {
      const [elm] = options;
      const value = Array.isArray(elm) ? elm[0] : elm;
      form.setFieldValue(field.name, value);
    }
  }

  onBlur = (args: any) => {
    const { field, onBlur } = this.props;
    field.onBlur(args);

    if (onBlur) onBlur(args);
  };

  onChange = (option: any) => {
    if (!option) return;

    const { field, form, onChange } = this.props;
    form.setFieldValue(field.name, option.value);
    if (onChange) onChange(option);
  };

  render() {
    const {
      className = "",
      field,
      form,
      options,
      wrapper = {},
      ...props
    } = this.props;
    const { errors, touched } = form;
    const error = getIn(touched, field.name) && getIn(errors, field.name);
    const value =
      options?.find((option: any) => option.value === field.value) || null;

    return (
      <div {...wrapper}>
        <Select
          id={field.name}
          className={`${className} ${error ? "red-border" : ""}`}
          {...field}
          {...props}
          options={options}
          value={value}
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
        {error && <span className="text-danger">{error}</span>}
      </div>
    );
  }
}
